import * as React from "react";

const ReefBackgroundSVG = ({ width, height, bubbleEdgeOpacity = 0 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 2082 2627"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g opacity={0.7}>
        <mask
          id="bubble_mask"
          maskUnits="userSpaceOnUse"
          x="1"
          y="17"
          width="2086"
          height="2567"
        >
          <path
            d="M294.172 112.515C294.172 130.2 196.833 156.394 153.807 154.284C108.221 152.049 67.1482 145.326 48.5786 117.922C32.8184 88.9373 35.1017 48.0422 86.9768 48C135.376 47.9607 294.172 59.9008 294.172 112.515Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M688.201 319.99C688.201 345.831 564.212 356.141 495.683 352.764C427.154 349.386 293.824 330.074 293.824 292.889C293.824 256.964 381.049 243.098 490.704 243.098C564.222 243.098 688.201 267.048 688.201 319.99Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M495.516 398.973C495.516 421.552 409.793 430.487 363.8 428.451C317.806 426.415 233.965 411.263 233.965 388.847C233.964 367.191 292.506 358.832 366.101 358.832C415.443 358.832 495.516 367.058 495.516 398.973Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1817.19 49.2408C1817.19 67.2693 1731.53 74.4036 1685.57 72.778C1639.6 71.1524 1552.36 50.0235 1552.36 32.1252C1552.36 14.8337 1614.32 17.1901 1687.87 17.1901C1737.18 17.1901 1817.19 23.7585 1817.19 49.2408Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1809 544.6C1809 562.161 1723.71 569.111 1677.95 567.527C1632.19 565.944 1549.09 570.217 1549.09 541.18C1549.09 524.337 1607.02 513.379 1680.24 513.379C1729.33 513.379 1809 519.777 1809 544.6Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1718.81 461.836C1718.81 479.596 1667.46 505.59 1621.85 503.988C1576.23 502.387 1459.72 487.743 1459.72 458.378C1459.72 418.39 1548.86 404.645 1621.85 404.645C1670.78 404.645 1718.81 436.732 1718.81 461.836Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1755.71 2530.89C1755.71 2553.23 1697.05 2585.92 1644.93 2583.91C1592.82 2581.89 1459.72 2563.48 1459.72 2526.54C1459.72 2476.24 1561.55 2458.95 1644.93 2458.95C1700.84 2458.95 1755.71 2499.31 1755.71 2530.89Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M578.336 504.825C578.336 456.056 395 439.134 339.712 442.302C284.425 445.471 260.487 475.745 260.487 510.63C260.487 544.332 251.246 559.211 339.712 559.211C399.025 559.211 578.336 559.211 578.336 504.825Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M616.049 178.981C616.049 214.498 533.938 224.467 340.789 224.467C295.161 224.467 320.966 210.998 302.401 183.737C286.644 154.904 288.927 114.222 340.789 114.18C389.177 114.141 616.049 126.642 616.049 178.981Z"
            fill="url(#bubble_radial)"
          />
          <ellipse
            cx="174.074"
            cy="1227.55"
            rx="154.589"
            ry="64.8266"
            fill="url(#bubble_radial)"
          />
          <path
            d="M908.884 754.56C907.893 793.397 843.485 820.271 767.292 818.326C691.098 816.38 630.248 777.266 631.239 738.429C632.23 699.592 694.687 675.738 770.88 677.684C847.074 679.629 909.875 715.723 908.884 754.56Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1156.5 766.165C1156.01 785.192 1110.56 798.004 1056.6 796.626C1002.64 795.248 959.336 775.741 959.822 756.714C960.307 737.686 1004.4 726.344 1058.36 727.722C1112.32 729.1 1156.99 747.138 1156.5 766.165Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M579.867 570.983C580.944 613.218 710.425 658.426 856.169 667.585C1005.3 676.958 1140.09 636.966 1139.01 594.731C1137.93 552.496 975.474 509.074 829.127 512.81C682.781 516.547 578.789 528.748 579.867 570.983Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M519.889 424.703C520.74 458.045 615.509 484.099 721.057 491.572C829.06 499.22 928.353 474.699 928.353 433.938C928.361 389.706 805.779 374.515 699.816 377.22C593.853 379.926 519.039 391.361 519.889 424.703Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1556.23 657.5C1555.7 678.498 1474.42 691.842 1377.65 689.371C1325.92 714.298 1198.86 690.808 1198.86 660.24C1199.4 639.242 1284.6 604.428 1379.59 613.331C1476.36 615.802 1556.77 636.502 1556.23 657.5Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1153.71 943.345C1152.57 987.75 1057.56 1017.06 914.113 1013.39C770.67 1009.73 629.703 964.062 630.836 919.657C631.969 875.253 749.071 849.147 892.515 852.809C1035.96 856.471 1154.84 898.941 1153.71 943.345Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1476.91 853.371C1475.78 897.776 1402.8 914.697 1303.31 912.157C1203.82 909.617 1113.21 878.18 1114.34 833.776C1115.09 804.664 1203.81 768.377 1303.3 770.917C1402.79 773.457 1478.04 808.967 1476.91 853.371Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M628.852 666.532C627.719 710.936 543.122 727.561 427.691 724.614C312.26 721.667 207.012 689.856 208.145 645.452C208.888 616.34 311.669 580.412 427.1 583.359C542.53 586.306 629.985 622.127 628.852 666.532Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1843.92 938.785C1842.78 983.189 1732.65 996.573 1633.16 994.033C1533.67 991.493 1480.22 963.594 1481.35 919.19C1482.09 890.077 1570.83 845.255 1670.32 847.795C1769.81 850.335 1845.05 894.381 1843.92 938.785Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1505.73 1010.27C1504.84 1045.27 1446.22 1077.15 1347.67 1074.64C1249.13 1072.12 1164.12 1049.82 1165.25 1005.41C1165.99 976.301 1225.84 927.503 1334.55 930.279C1433.09 932.795 1506.87 965.864 1505.73 1010.27Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1799.44 759.601C1798.73 787.671 1738.58 815.931 1640.04 813.415C1553.2 824.039 1454.19 805.282 1455.1 769.668C1455.69 746.318 1520.71 707.524 1629.42 710.3C1727.96 712.816 1800.35 723.987 1799.44 759.601Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1762.9 1262.01C1762.01 1297.01 1676.11 1320.9 1577.56 1318.38C1479.02 1315.86 1422.43 1301.58 1422.42 1257.16C1422.4 1205.89 1510.73 1200.62 1619.44 1203.39C1717.98 1205.91 1764.03 1217.61 1762.9 1262.01Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1455.48 1156.54C1454.65 1189.07 1405.44 1218.84 1322.87 1216.74C1240.29 1214.63 1169.1 1194.1 1170.15 1152.82C1170.84 1125.76 1214.09 1095.46 1305.18 1097.78C1369.53 1099.43 1456.31 1124 1455.48 1156.54Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M730.372 1181.62C729.542 1214.15 668.686 1245.56 562.941 1242.86C457.196 1240.16 363.265 1199.67 364.319 1158.4C365.009 1131.34 441.934 1107.3 558.581 1110.28C640.981 1112.38 731.202 1149.09 730.372 1181.62Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1293.63 1403.87C1294.85 1446.49 1235.93 1494.87 1114.03 1498.36C992.129 1501.85 873.855 1460.76 872.675 1419.49C870.98 1360.25 960.819 1330.35 1095.29 1326.5C1190.28 1323.78 1292.09 1350.25 1293.63 1403.87Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1344.62 1411.87C1344.62 1435.14 1408.21 1492.89 1530.11 1496.38C1652.01 1499.87 1764.39 1468.76 1765.57 1427.49C1766.63 1390.25 1631.44 1347.21 1496.97 1343.36C1401.98 1340.64 1344.62 1358.23 1344.62 1411.87Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M651.714 1016.52C651.714 1054.03 608.058 1088.03 486.157 1091.51C364.256 1095 209.64 1053.72 208.46 1012.45C207.395 975.213 201.75 927.251 336.219 923.402C563 916.91 651.714 962.879 651.714 1016.52Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M954.096 1546.48C955.315 1589.1 879.383 1626.71 757.482 1630.2C635.582 1633.69 517.308 1592.6 516.128 1551.33C514.433 1492.09 604.272 1462.19 738.74 1458.34C833.729 1455.62 952.562 1492.86 954.096 1546.48Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M120.667 1713.8C119.278 1762.34 195.069 1804.87 316.97 1808.36C438.87 1811.85 557.32 1764.58 558.665 1717.58C560.595 1650.11 470.865 1616.42 336.396 1612.57C241.407 1609.85 122.413 1652.73 120.667 1713.8Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M838.135 1352.22C837.366 1394.86 747.144 1428.66 605.222 1426.09C463.3 1423.53 326.731 1372.16 327.476 1330.88C328.546 1271.63 415.196 1260.56 571.749 1263.39C682.34 1265.39 838.905 1309.59 838.135 1352.22Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M512.391 1485.98C512.391 1515.86 421.4 1562.41 279.478 1559.85C137.556 1557.29 0.986402 1505.92 1.7316 1464.63C2.80117 1405.38 89.0771 1417.42 245.631 1420.24C356.221 1422.24 512.391 1423.99 512.391 1485.98Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1589.02 1816.82C1590.24 1859.44 1513.61 1897.08 1390.61 1900.6C1267.6 1904.12 1148.27 1863.06 1147.09 1821.78C1145.4 1762.54 1236.06 1732.62 1371.74 1728.74C1467.59 1726 1587.48 1763.2 1589.02 1816.82Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M580.047 831.488C580.854 859.704 503.885 885.369 380.882 888.89C257.88 892.411 138.979 866.369 138.197 839.046C137.076 799.829 227.997 779.137 363.681 775.253C459.528 772.509 579.031 795.99 580.047 831.488Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1535.23 1709.44C1534.13 1748.1 1610.85 1782.44 1733.85 1785.96C1856.85 1789.48 1976.07 1752.55 1977.14 1715.11C1978.67 1661.38 1887.94 1634 1752.26 1630.12C1656.41 1627.38 1536.63 1660.8 1535.23 1709.44Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1565.06 1552.12C1564.03 1588.43 1628.86 1627.35 1751.86 1630.87C1874.86 1634.39 2014.72 1598.77 2015.72 1563.62C2017.17 1513.16 1926.92 1507.26 1791.23 1503.37C1695.38 1500.63 1566.37 1506.45 1565.06 1552.12Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1122.15 1762.73C1123.37 1805.35 1055.31 1850.21 895.374 1850.21C707.326 1850.21 591.025 1798.08 589.845 1756.8C588.15 1697.57 709.677 1656.58 844.145 1652.73C978.613 1648.88 1120.61 1709.11 1122.15 1762.73Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1551.26 1594.43C1552.79 1647.92 1482.04 1708.54 1335.52 1712.73C1189 1716.93 979.32 1658.89 977.839 1607.1C975.712 1532.76 1186.5 1507.73 1312.73 1497.04C1426.55 1487.4 1549.34 1527.14 1551.26 1594.43Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1420.13 1299.63C1419.72 1315.88 1398.05 1332.52 1328.92 1330.76C1259.79 1328.99 1206.63 1307.75 1207.09 1289.63C1207.64 1268.31 1231.39 1250.23 1307.67 1250.23C1357.66 1250.24 1420.55 1283.38 1420.13 1299.63Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1465.68 1103.53C1466.28 1127.13 1514.03 1177.38 1620.05 1174.67C1726.07 1171.96 1792.93 1108.75 1792.47 1090.62C1791.92 1069.31 1737.01 1038.62 1620.05 1039.66C1543.4 1040.34 1464.78 1068.39 1465.68 1103.53Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1806.54 1995.09C1805.41 2039.49 1695.28 2052.87 1595.79 2050.33C1496.3 2047.79 1442.84 2019.89 1443.97 1975.49C1444.72 1946.38 1533.45 1901.56 1632.94 1904.1C1732.43 1906.64 1807.67 1950.68 1806.54 1995.09Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1654.85 2314.47C1653.96 2349.47 1568.06 2373.35 1469.51 2370.84C1370.97 2368.32 1314.38 2354.03 1314.37 2309.61C1314.35 2258.35 1402.68 2253.07 1511.39 2255.85C1609.93 2258.36 1655.98 2270.06 1654.85 2314.47Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1428.29 2159.85C1428.9 2183.45 1476.65 2233.7 1582.66 2230.99C1688.68 2228.28 1755.54 2165.07 1755.08 2146.94C1754.54 2125.63 1699.62 2094.94 1582.66 2095.98C1506.02 2096.66 1427.4 2124.71 1428.29 2159.85Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1174.6 1082.8C1174.6 1099.65 1132.54 1125.16 1063.41 1123.4C994.281 1121.63 949.26 1102.15 949.722 1084.02C950.266 1062.71 979.712 1035.93 1068.41 1035.93C1118.39 1035.93 1175.3 1055.28 1174.6 1082.8Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M915.464 1084.52C915.511 1101.38 867.8 1132.86 791.039 1130.9C714.278 1128.94 665.311 1103.24 665.773 1085.11C666.317 1063.8 687.559 1031.91 786.041 1032.16C841.545 1032.3 916.166 1057.01 915.464 1084.52Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M185.964 1094.79C171.501 1113.84 122.068 1123.06 78.3241 1088.83C34.5807 1054.61 28.6846 1003.25 44.5412 982.985C75.0646 943.971 117.114 945.604 175.183 986.957C207.91 1010.26 210.036 1064.02 185.964 1094.79Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1431.75 441.106C1431.88 453.063 1390.01 470.852 1320.88 469.087C1251.76 467.322 1223.63 450.059 1223.96 437.203C1224.34 422.086 1254.57 407.067 1325.23 407.068C1375.21 407.069 1432.25 421.59 1431.75 441.106Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1166.9 551.547C1166.75 573.88 1236.68 607.32 1352 604.376C1467.31 601.431 1514.14 569.33 1513.53 545.317C1512.81 517.078 1462.31 488.87 1344.43 488.512C1261.05 488.259 1165.97 515.091 1166.9 551.547Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1230.17 1919.77C1230.17 1937.58 1144.88 1944.63 1099.12 1943.02C1053.36 1941.42 970.254 1945.75 970.254 1916.3C970.254 1899.22 1028.19 1888.1 1101.41 1888.1C1150.5 1888.1 1230.17 1894.59 1230.17 1919.77Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M548.58 2141.95C547.502 2184.18 432.976 2212.27 296.891 2208.8C160.805 2205.32 51.4555 2161.69 52.5331 2119.45C53.6107 2077.22 164.708 2052.38 300.793 2055.85C436.878 2059.33 549.658 2099.71 548.58 2141.95Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1.32769 1946.39C2.40531 1988.63 131.886 2033.84 277.63 2043C426.764 2052.37 561.548 2012.38 560.47 1970.14C559.393 1927.91 396.935 1884.48 250.588 1888.22C104.241 1891.96 0.250056 1904.16 1.32769 1946.39Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1401.89 2025.33C1401.14 2054.95 1286.85 2073.78 1150.76 2070.31C1076.68 2070.31 899.358 2072.36 899.358 2029.23C900.114 1999.61 1019.92 1950.49 1153.5 1963.04C1289.59 1966.51 1402.65 1995.71 1401.89 2025.33Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M898.377 2228.78C897.244 2273.18 824.264 2290.1 724.775 2287.56C625.286 2285.02 534.676 2253.59 535.809 2209.18C536.552 2180.07 625.274 2143.78 724.763 2146.32C824.251 2148.86 899.51 2184.37 898.377 2228.78Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1265.39 2314.18C1264.25 2358.59 1154.12 2371.97 1054.63 2369.43C955.143 2366.89 901.685 2338.99 902.818 2294.59C903.561 2265.48 992.298 2220.65 1091.79 2223.19C1191.28 2225.73 1266.52 2269.78 1265.39 2314.18Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1231.91 2145.14C1231.19 2173.21 1171.05 2201.47 1072.5 2198.96C985.661 2209.58 886.652 2190.82 887.56 2155.21C888.156 2131.86 953.175 2093.07 1061.88 2095.84C1160.43 2098.36 1232.82 2109.53 1231.91 2145.14Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M887.594 2077.89C887.688 2101.81 818.895 2137.79 705.597 2134.9C592.298 2132.01 519.212 2093.31 519.869 2067.59C521.132 2018.07 591.37 1995.23 736.726 1995.73C818.648 1996.01 888.59 2038.84 887.594 2077.89Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M588.359 1926.95C588.212 1949.29 658.145 1982.73 773.456 1979.78C888.767 1976.84 935.605 1944.74 934.992 1920.72C934.272 1892.48 883.767 1864.28 765.887 1863.92C682.509 1863.67 587.429 1890.5 588.359 1926.95Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1607.54 352.891C1607.93 364.855 1516.99 399.481 1405.75 396.641C1294.51 393.8 1269.98 353.533 1270.31 340.678C1271.02 312.839 1342.68 301.739 1456.36 302.839C1536.77 303.617 1608.04 333.375 1607.54 352.891Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1572.98 79.1154C1573.26 91.0765 1552.07 113.397 1457.61 110.985C1363.15 108.573 1289.04 97.2359 1289.04 73.2686C1289.04 55.9892 1353.58 34.7058 1450.12 35.3678C1518.4 35.8361 1573.48 59.5994 1572.98 79.1154Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1278.31 95.3463C1278.36 103.995 1254.2 114.656 1210.95 113.551C1167.69 112.447 1150.13 100.03 1150.36 90.7297C1150.64 79.7934 1169.6 68.8539 1213.82 68.6788C1245.1 68.555 1278.67 81.2281 1278.31 95.3463Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1089.03 194.819C1089.08 203.468 1053.58 226.44 1010.32 225.335C967.062 224.231 950.014 209.764 950.252 200.464C950.531 189.527 977.342 173.654 1021.56 173.479C1052.84 173.355 1089.39 180.701 1089.03 194.819Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1118.41 98.4944C1118.41 132.255 971.622 165.347 801.041 160.992C630.461 156.637 562.98 117.246 562.984 101.767C562.996 63.4876 714.841 37.2457 889.13 40.3914C1012.4 42.6164 1118.41 64.7335 1118.41 98.4944Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M328.327 174.243C328.405 194.167 294.167 206.96 212.125 204.865C130.082 202.771 80.9361 177.432 80.9375 164.886C80.9386 155.512 119.551 135.308 203.394 136.144C262.697 136.736 328.248 154.319 328.327 174.243Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M312.016 275.22C312.016 293.756 261.218 312.369 167.921 309.987C74.6236 307.605 36.0144 284.381 36.0175 266.823C36.021 246.878 98.1932 223.883 193.533 225.013C260.968 225.812 312.017 256.682 312.016 275.22Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1092.13 157.845C1091.58 135.973 1164.64 127.899 1311.42 124.151C1458.2 120.404 1532.58 148.472 1532.57 170.344C1532.57 197.851 1466.39 226.221 1316.42 222.836C1205.84 220.34 1092.83 185.261 1092.13 157.845Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1540.7 272.819C1540.83 284.776 1526.33 299.237 1457.21 297.472C1388.08 295.708 1359.95 278.445 1360.28 265.589C1360.66 250.472 1388.82 234.711 1459.48 234.712C1509.46 234.713 1541.2 253.303 1540.7 272.819Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1700.63 238.724C1700.75 250.681 1690.43 263.363 1621.3 261.598C1552.17 259.833 1519.87 244.349 1520.2 231.494C1520.59 216.376 1563.13 192.244 1633.79 192.245C1683.77 192.246 1701.12 219.208 1700.63 238.724Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1733.04 142.237C1733.17 154.194 1696.67 168.355 1627.54 166.59C1558.41 164.825 1548.2 148.466 1548.2 138.467C1548.2 118.469 1592.45 111.598 1663.11 111.6C1713.09 111.601 1733.54 122.721 1733.04 142.237Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1209.59 474.113C1209.7 489.93 1150.87 514.306 1068.42 512.201C985.974 510.096 946.022 505.951 946.941 469.914C947.452 449.916 1002.88 424.942 1087.16 424.709C1146.78 424.544 1210.25 448.296 1209.59 474.113Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1263.44 379.078C1263.44 402.2 1209.26 409.35 1126.51 407.238C1043.77 405.125 1014.39 386.986 1014.72 374.13C1015.1 359.013 1087.78 343.878 1135.88 344.081C1195.7 344.333 1263.94 359.562 1263.44 379.078Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M938.782 222.915C940.302 245.991 887.297 269.408 786.038 272.912C684.778 276.416 634.498 247.707 634.496 234.848C634.492 201.668 732.237 188.477 791.039 185.417C864.159 181.611 938.78 187.85 938.782 222.915Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1012.81 334.727C1012.81 357.849 975.333 375.933 903.479 374.098C820.734 371.986 716.051 350.334 716.054 320.347C716.056 305.225 751.054 291.158 852.887 291.587C912.706 291.839 1013.31 315.211 1012.81 334.727Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1323.93 270.407C1324.16 293.535 1242.25 326.398 1127.15 323.459C1012.05 320.52 974.228 290.968 974.225 271.168C974.221 244.09 1060.24 229.728 1127.15 230.411C1210.34 231.26 1323.94 235.341 1323.93 270.407Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1093.2 2508.71C1093.58 2520.68 1002.64 2555.3 891.404 2552.46C780.165 2549.62 755.632 2509.35 755.96 2496.5C756.67 2468.66 828.333 2457.56 942.014 2458.66C1022.42 2459.44 1093.69 2489.2 1093.2 2508.71Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M574.653 2350.65C574.701 2359.3 539.198 2382.27 495.94 2381.16C452.683 2380.06 435.635 2365.59 435.873 2356.29C436.152 2345.36 462.963 2329.48 507.185 2329.31C538.464 2329.18 575.013 2336.53 574.653 2350.65Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1972.9 1966.82C1972.95 1975.46 1937.44 1998.44 1894.19 1997.33C1850.93 1996.23 1833.88 1981.76 1834.12 1972.46C1834.4 1961.52 1861.21 1945.65 1905.43 1945.47C1936.71 1945.35 1973.26 1952.7 1972.9 1966.82Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1083.61 2423.01C1083.05 2401.14 1156.11 2393.06 1302.89 2389.32C1449.67 2385.57 1524.05 2413.64 1524.05 2435.51C1524.04 2463.01 1457.86 2491.39 1307.89 2488C1197.31 2485.5 1084.31 2450.42 1083.61 2423.01Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M749.076 2534.92C749.076 2558.04 694.893 2565.19 612.149 2563.08C529.404 2560.97 500.024 2542.83 500.352 2529.97C500.738 2514.85 573.415 2499.72 621.521 2499.92C681.34 2500.17 749.574 2515.4 749.076 2534.92Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M424.407 2378.73C425.927 2401.8 372.922 2425.22 271.663 2428.72C170.403 2432.23 120.123 2403.52 120.121 2390.66C120.117 2357.48 217.862 2344.29 276.664 2341.23C349.784 2337.42 424.405 2343.66 424.407 2378.73Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M498.43 2490.55C498.43 2513.67 460.954 2531.75 389.1 2529.92C306.356 2527.81 201.672 2506.15 201.675 2476.17C201.677 2461.05 236.675 2446.98 338.508 2447.41C398.327 2447.66 498.928 2471.03 498.43 2490.55Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2014.41 2400.99C2014.41 2424.11 1976.94 2442.2 1905.08 2440.36C1822.34 2438.25 1717.66 2416.6 1717.66 2386.61C1717.66 2371.49 1752.66 2357.42 1854.49 2357.85C1914.31 2358.1 2014.91 2381.48 2014.41 2400.99Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2048.1 2199.52C2047.58 2243.01 2009.67 2277.86 1937.82 2276.03C1855.08 2273.91 1750.82 2235.55 1751.5 2179.15C1751.84 2150.71 1787.17 2123.47 1889.05 2121.99C1948.9 2121.12 2049.03 2162.81 2048.1 2199.52Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M809.551 2426.23C809.782 2449.36 727.865 2482.22 612.764 2479.28C497.663 2476.34 459.845 2446.79 459.842 2426.99C459.838 2399.91 545.858 2385.55 612.764 2386.23C695.962 2387.08 809.557 2391.16 809.551 2426.23Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M1176.91 1232.23C1177.31 1247.98 1154.64 1307.14 968.469 1307.14C839.744 1303.85 757.215 1271.46 758.323 1228.05C759.43 1184.63 841.019 1143.43 1034.06 1145.89C1127.12 1147.07 1177.57 1206.53 1176.91 1232.23Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2046.88 1283.08C2047.08 1296.58 2031.4 1347.4 1904.82 1348.25C1817.32 1346.01 1761.36 1318.61 1762.31 1281.4C1763.26 1244.18 1818.91 1208.48 1950.15 1209.71C2013.41 1210.31 2047.44 1261.05 2046.88 1283.08Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2070.33 169.457C2070.62 179.617 2055.1 217.758 1927.18 217.558C1838.73 215.3 1781.99 194.312 1782.7 166.309C1783.42 138.307 1839.43 111.814 1972.08 113.606C2036.02 114.47 2070.75 152.881 2070.33 169.457Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2035.1 1871.48C2035.39 1881.64 2019.87 1919.79 1891.95 1919.59C1803.5 1917.33 1746.76 1896.34 1747.47 1868.34C1748.18 1840.33 1804.2 1813.84 1936.85 1815.63C2000.79 1816.5 2035.52 1854.91 2035.1 1871.48Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2071.97 1067.76C2072.15 1081.74 2056.47 1134.37 1930.33 1135.36C1843.12 1133.14 1787.37 1104.83 1788.36 1066.3C1789.34 1027.76 1844.84 990.758 1975.64 991.902C2038.68 992.454 2072.55 1044.95 2071.97 1067.76Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2086.4 1456.82C2086.59 1470.8 2070.91 1523.43 1944.76 1524.43C1857.55 1522.2 1801.81 1493.89 1802.79 1455.36C1803.77 1416.83 1859.28 1379.82 1990.07 1380.96C2053.12 1381.52 2086.98 1434.02 2086.4 1456.82Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2062.12 467.133C2062.35 479.467 2046.83 525.869 1920.7 526.372C1833.49 524.145 1777.66 498.993 1778.53 464.988C1779.4 430.984 1834.79 398.49 1965.57 399.893C2028.62 400.569 2062.64 447.005 2062.12 467.133Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2049.54 329.098C2049.77 341.432 2034.25 387.834 1908.11 388.337C1820.91 386.11 1765.08 360.958 1765.95 326.953C1766.82 292.949 1822.21 260.455 1952.99 261.858C2016.04 262.534 2050.06 308.97 2049.54 329.098Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M2050.34 816.961C2050.61 827.481 2035.27 866.995 1909.14 866.95C1821.94 864.723 1766.02 843.063 1766.76 814.066C1767.5 785.07 1822.76 757.566 1953.54 759.254C2016.58 760.067 2050.77 799.797 2050.34 816.961Z"
            fill="url(#bubble_radial)"
          />
          <path
            d="M247.729 590.344C247.722 610.266 210.411 627.83 139.492 626.041C68.5737 624.253 35.8489 602.985 35.8541 590.441C35.8593 577.897 69.0506 561.201 141.531 561.725C192.796 562.095 247.736 570.422 247.729 590.344Z"
            fill="url(#bubble_radial)"
          />
        </mask>

        <g mask="url(#bubble_mask)">
          <rect
            y="1"
            width="2073"
            height="2626"
            fill="url(#bubble_overall_radial)"
          />
        </g>
      </g>
    </g>

    <defs>
      <radialGradient
        id="bubble_overall_radial"
        cx="0.5"
        cy="0.5"
        r="0.7"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#47C573" stopOpacity="1" />
        <stop offset="1" stopColor="#04BFCF" stopOpacity="1" />
      </radialGradient>

      <radialGradient
        id="back_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1032.48 1408.67) rotate(89.9987) scale(992.829 1670.36)"
      >
        <stop offset="0.129808" stopColor="#02FFD1" />
        <stop offset="0.528517" stopColor="#10DDCD" />
        <stop offset="1" stopColor="#01B6A8" />
      </radialGradient>

      <radialGradient id="bubble_radial" cx="50%" cy="50%" r="80%">
        <stop offset="0" stopColor="white" stopOpacity="1" />
        <stop offset="1" stopColor="white" stopOpacity={bubbleEdgeOpacity} />
      </radialGradient>
    </defs>
  </svg>
);

export default React.memo(
  ReefBackgroundSVG,
  (prev, next) => prev.width === next.width && prev.height === next.height
);
